import { useMutation, UseMutationResult } from '@tanstack/react-query';
import {
  updateParkingContract,
  uploadParkingContractAttachment,
  deleteParkingContractAttachment,
} from '../../api/parking-contract.ts';
import type {
  UpdateParkingContractRequest,
  UploadParkingContractAttachmentRequest,
  DeleteParkingContractAttachmentRequest,
} from '../../api/requests/parking-contract-request.ts';

async function updateAll(
  updateRequest?: UpdateParkingContractRequest,
  uploadRequest?: UploadParkingContractAttachmentRequest,
  deleteRequest?: DeleteParkingContractAttachmentRequest,
) {
  const promises = [];
  if (updateRequest) {
    promises.push(updateParkingContract(updateRequest));
  }
  if (uploadRequest) {
    promises.push(uploadParkingContractAttachment(uploadRequest));
  }
  if (deleteRequest) {
    promises.push(deleteParkingContractAttachment(deleteRequest));
  }
  await Promise.all(promises);
}

export default function useUpdateParkingContract(): UseMutationResult<
  void,
  Error,
  [
    UpdateParkingContractRequest | null,
    UploadParkingContractAttachmentRequest | null,
    DeleteParkingContractAttachmentRequest | null,
  ]
> {
  return useMutation({
    mutationFn: ([updateRequest, uploadRequest, deleteRequest]) =>
      updateAll(updateRequest, uploadRequest, deleteRequest),
  });
}
